import React from "react";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";

interface AlertModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
}

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, message }) => {
    return (
        <Dialog
            headerClassName="d-none"
            dismissableMask
            visible={isOpen}
            className="custom_modal_dialog modal_dialog_sm"
            onHide={onClose}
            draggable={false}
            resizable={false}
        >
            <div className="custom_modal_body">
                <button className="custom_modal_close position-absolute float p-ripple"
                    onClick={onClose}>
                    <i className="bi bi-x-lg"></i>
                    <Ripple />
                </button>
                <div className="alert_modal_container">
                    {/* <img src="/assets/images/icons/waiting.svg" alt="" /> */}
                    <h6>{message}</h6>
                    <Button label="Ok" className="custom_btn secondary" onClick={onClose} />
                </div>
            </div>
        </Dialog>
    )
}

export default AlertModal;